import React from "react";
import "./footer.css";
import tiktok from "global_assets/social-icons/tiktok.png";
import instagram from "global_assets/social-icons/instagram.png";
import spotify from "global_assets/social-icons/spotify.png";
import bandcamp from "global_assets/social-icons/bandcamp.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="icon-row">
          <a href="https://www.tiktok.com/@cherry.crisis?_t=8mQYIEknv0l&_r=1">
            <img src={tiktok} alt="tiktok" />
          </a>
          <a href="https://www.instagram.com/cherry.crisis">
            <img src={instagram} alt="instagram" />
          </a>
          <a href="https://open.spotify.com/artist/2HuOLspUSWpwDlsX9WDblu?si=9VZ9QofBTQeFFpxuqnnrQg">
            <img src={spotify} alt="spotify" />
          </a>
          <a
            href="https://cherrycrisis.bandcamp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={bandcamp} alt="soundcloud" />
          </a>
          <a
            href="https://linktr.ee/cherrycrisis"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="more-links">more links</button>
          </a>
        </div>
        <p className="rights">© 2024 Cherry Crisis. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
